import { mapDtoToImage } from './common-mappers'

export const mapDtoToRestaurant = dto => ({
  id: dto.id,
  name: dto.name?.trim(),
  phone: dto.phone,
  deliveryPhone: dto.phone_delivery,
  icon: dto.icon && mapDtoToImage(dto.icon)
})
